import React from "react"
import { connect } from "react-redux"
import { Button, Select } from "semantic-ui-react"
import Notifications from '../../Notifications'

class IssuesTab extends React.Component {
  constructor(props) {
    super(props)

    this.state = this.defaultState()
  }

  defaultState = () => {
    const { orderIssue } = this.props

    return {
      issueId: orderIssue && orderIssue.id,
      reasonId: orderIssue && orderIssue.order_issue_reason_id
    }
  }

  selectIssue = (_event, obj) => {
    this.setState({ issueId: obj.value, reasonId: undefined })
  }

  selectReason = (_event, obj) => {
    this.setState({ reasonId: obj.value })
  }

  handleCancel = () => {
    this.setState(this.defaultState())
  }

  onSubmit = () => {
    const { issueId, reasonId } = this.state
    if (issueId == null || reasonId == null) {
      this.props.dispatch(Notifications.error({ message: "Please select an Issue and a Reason." }))
      return
    }

    this.props.updateOrder({ order_issues: [{ id: issueId, order_issue_reason_id: reasonId }] })
  }

  render() {
    const { allIssues } = this.props
    const { issueId, reasonId } = this.state
    const marginTop = { marginTop: "15px" }
    const issueOptions = allIssues.map(issue => {
      return { key: issue.name, text: `${issue.name} Issue`, value: issue.id }
    })
    const issue = issueId && allIssues.find(i => i.id === issueId)
    const reasonOptions = (issue && issue.order_issue_reasons.map(r => {
      return { key: r.description, text: r.description, value: r.id }
    })) || []

    return (
      <React.Fragment>
        <h4>Issue:</h4>
        <Select
          style={{width: '50%'}}
          fluid
          selection
          placeholder='Issue'
          options={issueOptions}
          value={issueId}
          onChange={this.selectIssue}
        />

        <Select
          style={{width: '50%', marginTop: '20px'}}
          fluid
          selection
          search
          disabled={!issueId}
          placeholder='Reason'
          options={reasonOptions}
          value={reasonId}
          onChange={this.selectReason}
        />
        <div style={marginTop}>
          <Button
            primary
            disabled={issueId == null || reasonId == null}
            onClick={this.onSubmit}
            type="submit"
            value="Filter"
          >
            Save
          </Button>
          <Button secondary type="button" value="Filter" onClick={this.handleCancel}>
            Cancel
          </Button>
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => {
  const issues = state.orderIssues || {}

  return { allIssues: issues.orderIssues || [] }
}

export default connect(mapStateToProps)(IssuesTab)
